module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "progressive-image",
    class: [("mode-" + _vm.mode)],
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('lazy-component', {
    ref: "lazyWrapper",
    staticClass: "lazy-wrapper",
    on: {
      "show": _vm.handler
    }
  }, [(_vm.mode === 'background') ? [_c('div', {
    staticClass: "image",
    class: {
      loaded: _vm.imageLoaded
    },
    style: (_vm.backgroundImageStyle)
  }), _c('div', {
    staticClass: "blur-image",
    class: {
      'fade-out': _vm.imageLoaded
    },
    style: (_vm.blurBackgroundImageStyle)
  })] : [(_vm.imageSrc) ? _c('img', {
    staticClass: "image",
    class: {
      loaded: _vm.imageLoaded
    },
    style: (_vm.customStyle),
    attrs: {
      "alt": _vm.progressiveImage.alt,
      "src": _vm.imageSrc
    }
  }) : _vm._e(), _c('img', {
    staticClass: "blur-image",
    class: {
      'fade-out': _vm.imageLoaded
    },
    style: (_vm.customStyle),
    attrs: {
      "src": _vm.progressiveImage.loading,
      "alt": _vm.progressiveImage.alt
    }
  })]], 2), (_vm.mode === 'background') ? [_c('div', {
    staticClass: "blur-image blur-holder",
    class: {
      'fade-out': _vm.imageLoaded
    },
    style: (_vm.blurBackgroundImageStyle)
  })] : [_c('img', {
    staticClass: "blur-holder blur-image",
    class: {
      'fade-out': _vm.imageLoaded
    },
    attrs: {
      "src": _vm.progressiveImage.loading,
      "width": _vm.width,
      "height": _vm.height
    }
  })], _c('img', {
    staticClass: "holder",
    attrs: {
      "src": _vm.progressiveImage.holder,
      "width": _vm.width,
      "height": _vm.height
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b77e75d","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/widgets/ProgressiveImage.vue
// module id = 937
// module chunks = 1 2 3 4 5 6 8 24